import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAvatarComponent } from 'shared/user-avatar/user-avatar.component';
import { AppTooltipModule } from 'shared/tooltip/tooltip.module';
import { UserAvatarModule } from 'shared/user-avatar/user-avatar.module';
import { PipesModule } from 'shared/pipes/pipes.module';
import { EmptyStateModule } from 'shared/empty-state/empty-state.module';

import { ButtonModule } from '../button/button.module';
import { LogsService } from './logs.service';
import { LogsComponent } from './logs.component';
import { LogComponent } from './component/log/log.component';


@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        AppTooltipModule,
        UserAvatarModule,
        PipesModule,
        EmptyStateModule,
    ],
    declarations: [
        LogComponent,
        LogsComponent,
    ],
    exports: [
        LogsComponent,
    ],
    providers: [LogsService]
})
export class LogsModule { }
